import React from 'react';

import { Stack } from '@atlaskit/primitives/compiled';

import { SnippetPanelSearchBarSkeleton } from './SnippetPanelSearchBarSkeleton.tsx';
import { SnippetCategorySelectorSkeleton } from './SnippetCategorySelectorSkeleton.tsx';
import { SnippetPanelItemSkeleton } from './SnippetPanelItemSkeleton.tsx';

export const SnippetPanelSkeleton = () => {
	return (
		<Stack space="space.200" grow="fill">
			<SnippetPanelSearchBarSkeleton />
			<SnippetCategorySelectorSkeleton />
			<Stack>
				<SnippetPanelItemSkeleton />
				<SnippetPanelItemSkeleton />
				<SnippetPanelItemSkeleton />
			</Stack>
		</Stack>
	);
};
